import { fetchFactory } from 'isotope-client'
import { ControleCatsBean } from '../model/controleCatsBean'

export const getCatsInfo = (token: string): Promise<ControleCatsBean> => fetchFactory(
	`/controle-cats/${token}`,
	{},
	'/api/public'
)